import { BillingInfo } from './billing-info.model';

export class AddBillingInfo {
  static readonly type = '[BillingInfo] Add BillingInfo';
  constructor(public payload: { key: string; value: string }) {}
}

export class UpdateBillingInfo {
  static readonly type = '[BillingInfo] Update BillingInfo';
  constructor(public payload: BillingInfo) {}
}
